// extracted by mini-css-extract-plugin
module.exports = {"permissionSelect":"PermissionSelect__permissionSelect___qFnvA"};